import React from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/core';

export const DropColumn = ({ id, dropState, className = '', children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });
  const ring = dropState === 'allowed'
    ? (isOver ? 'ring-2 ring-emerald-500 bg-emerald-50' : 'ring-2 ring-emerald-300')
    : dropState === 'blocked' ? 'opacity-50' : '';
  return (
    <div ref={setNodeRef} className={`${className} transition-[box-shadow,opacity,background-color] ${ring}`} data-testid={`kanban-col-${id}`} data-drop-state={dropState || 'idle'}>
      {children}
    </div>
  );
};

export const DragCard = ({ id, disabled, className = '', children, ...rest }) => {
  const { setNodeRef, listeners, attributes, isDragging } = useDraggable({ id, disabled });
  return (
    <div
      ref={setNodeRef}
      {...(disabled ? {} : attributes)}
      {...listeners}
      {...rest}
      className={`${className} ${isDragging ? 'opacity-30' : ''} ${disabled ? '' : 'touch-none'}`}
      data-draggable={disabled ? 'false' : 'true'}
    >
      {children}
    </div>
  );
};
